module.exports = __webpack_public_path__ + "img/36.b658d50f.jpg";